import { Injector } from '@angular/core';

export let appInjector: Injector;

export function setAppInjector(injector: Injector): void {
  appInjector = injector;
}
